/* eslint-disable consistent-return */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CardElement, ElementsConsumer } from '@stripe/react-stripe-js';
import axios from 'axios';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import DialogActions from '@material-ui/core/DialogActions';
import LinearProgress from '@material-ui/core/LinearProgress';
import * as actions from '../../actions/settings';

const CARD_OPTIONS = {
	style: {
		base: {
			iconColor: '#0f172a',
			color: '#0f172a',
			fontFamily: '"Geist Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
			fontWeight: 500,
			fontSize: '16px',
			fontSmoothing: 'antialiased',
			lineHeight: '24px',
			':-webkit-autofill': { color: '#0f172a' },
			'::placeholder': { color: '#94a3b8' }
		},
		invalid: {
			iconColor: '#ef4444',
			color: '#ef4444'
		}
	},
	hidePostalCode: true
};

const styles = {
	stripeBox: {
		backgroundColor: '#ffffff',
		border: '1px solid #e2e8f0',
		padding: '14px 12px',
		width: '100%',
		borderRadius: 12,
		transition: 'border-color 120ms ease, box-shadow 120ms ease'
	}
};

class UpdatePaymentForm extends Component {
	state = { loading: false, onHover: false, errorMessage: '' };

	handleSubmit = async (e) => {
		if (e.preventDefault) {
			e.preventDefault();
		}

		this.setState({ loading: true, errorMessage: '' });

		const { stripe, elements } = this.props;

		if (!stripe || !elements) {
			return this.setState({ loading: false });
		}

		const cardElement = elements.getElement(CardElement);

		try {
			const setupIntentRes = await axios.post('/api/billing/setup-intent');

			if (!setupIntentRes.data || !setupIntentRes.data.clientSecret) {
				return this.setState({
					errorMessage:
						'There was an error preparing your payment update. Please refresh the page and try again.',
					loading: false
				});
			}

			const { clientSecret } = setupIntentRes.data;

			const { error, setupIntent } = await stripe.confirmCardSetup(
				clientSecret,
				{
					payment_method: {
						card: cardElement
					}
				}
			);

			if (error) {
				return this.setState({
					errorMessage: error.message,
					loading: false
				});
			}

			const paymentMethod =
				typeof setupIntent.payment_method === 'string'
					? setupIntent.payment_method
					: setupIntent.payment_method && setupIntent.payment_method.id;

			if (!paymentMethod) {
				return this.setState({
					errorMessage:
						'There was an error updating your payment method. Please refresh the page and try again.',
					loading: false
				});
			}

			const response = await this.props.updatePaymentMethod(paymentMethod);

			if (response.error) {
				return this.setState({
					errorMessage: response.message,
					loading: false
				});
			}

			this.props.closeDialog(false);

			return this.setState({
				errorMessage: '',
				loading: false
			});
		} catch (err) {
			return this.setState({
				errorMessage:
					'There was an error updating your payment details. Please refresh the page and try again.',
				loading: false
			});
		}
	};

	mouseInStripe = () => {
		this.setState({ onHover: true });
	};

	mouseOutStripe = () => {
		this.setState({ onHover: false });
	};

	render() {
		const errorVisible = Boolean(this.state.errorMessage);

		return (
			<div>
				<div
					style={
						this.state.onHover
							? {
									...styles.stripeBox,
									border: '1px solid #0f172a',
									boxShadow: '0 0 0 4px rgba(15, 23, 42, 0.08)'
							  }
							: styles.stripeBox
					}
					onMouseEnter={this.mouseInStripe}
					onMouseLeave={this.mouseOutStripe}
				>
					<CardElement
						options={{
							...CARD_OPTIONS,
							disabled: this.state.loading
						}}
					/>
				</div>

				{this.state.loading && (
					<div
						style={{
							marginTop: 2,
							paddingLeft: 2,
							paddingRight: 10
						}}
					>
						<LinearProgress />
					</div>
				)}

				<Typography
					style={{
						marginTop: 8,
						fontSize: '0.8rem',
						color: errorVisible ? '#ef4444' : '#64748b',
						minHeight: 18
					}}
				>
					{errorVisible
						? this.state.errorMessage
						: 'Your card details are securely handled by Stripe.'}
				</Typography>
				<DialogActions style={{ paddingTop: 20 }}>
					<Button
						color="primary"
						variant="text"
						onClick={() => this.props.closeDialog(false)}
					>
						Cancel
					</Button>
					<Button
						color="primary"
						variant="contained"
						type="submit"
						disabled={!this.props.stripe || this.state.loading}
						aria-label="Update credit card"
						title="Update credit card"
						onClick={this.handleSubmit}
					>
						Update
					</Button>
				</DialogActions>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		auth: state.auth
	};
}

const InjectedPaymentForm = ({ closeDialog, updatePaymentMethod }) => (
	<ElementsConsumer>
		{({ elements, stripe }) => (
			<UpdatePaymentForm
				elements={elements}
				stripe={stripe}
				closeDialog={closeDialog}
				updatePaymentMethod={updatePaymentMethod}
			/>
		)}
	</ElementsConsumer>
);

export default connect(mapStateToProps, actions)(InjectedPaymentForm);



// WEBPACK FOOTER //
// ./src/components/settings/UpdatePaymentForm.js